import Format from '../../../utils/Formatter';
import { optionsFromTo } from '../../../utils/helpers';
import I18n from '../../../config/i18n';

export const renderArrivalDepartureString = ({ start_date, end_date, checkin, checkout }) => {
  const arrivalDate = Format.date(start_date);
  const departureDate = Format.date(end_date);
  const checkinTime = checkin ? `(${I18n.t('booking.from')} ${Format.time(checkin)})` : '';
  const checkoutTime = checkout ? `(${I18n.t('booking.to')} ${Format.time(checkout)})` : '';
  return `${arrivalDate} ${checkinTime} – ${departureDate} ${checkoutTime}`;
};

export const getTosLink = (props) =>
  props.is_holiday_home
    ? props.tos_link.hh
    : props.tos_link[props.insurance_country] || props.tos_link.en;

export const travelerOptions = {
  adult: (props) => optionsFromTo(1, props.max_persons + 1, 'booking.traveler_options.adult'),
  allChildren: (props) =>
    optionsFromTo(0, props.max_children + 1, 'booking.traveler_options.all_children'),
  child: (props) => optionsFromTo(0, props.max_children + 1, 'booking.traveler_options.child'),
  babyParts: (props) =>
    optionsFromTo(0, props.max_infants + 1, 'booking.traveler_options.baby_parts'),
  baby: (props) => optionsFromTo(0, props.max_infants + 1, 'booking.traveler_options.baby'),
  pets: () => optionsFromTo(0, 5, 'booking.traveler_options.pet'),
};

export const listTravelers = (props) => {
  const travelers = [];
  if (props.number_of_adults) {
    travelers.push(I18n.t('booking.traveler_options.adult', { count: props.number_of_adults }));
  }
  if (props.number_of_children) {
    travelers.push(
      props.is_holiday_home
        ? I18n.t('booking.traveler_options.all_children', { count: props.number_of_children })
        : I18n.t('booking.traveler_options.child', { count: props.number_of_children }),
    );
  }
  if (props.number_of_infants) {
    travelers.push(
      props.is_holiday_home
        ? I18n.t('booking.traveler_options.baby_parts', { count: props.number_of_infants })
        : I18n.t('booking.traveler_options.baby', { count: props.number_of_infants }),
    );
  }
  if (props.number_of_pets) {
    travelers.push(I18n.t('booking.traveler_options.pet', { count: props.number_of_pets }));
  }
  return travelers;
};

export const filterExtraCosts = (props) =>
  props.extraCosts ? props.extraCosts.filter((extra) => !extra.included) : [];

export default {
  renderArrivalDepartureString,
  getTosLink,
  travelerOptions,
  listTravelers,
  filterExtraCosts,
};
